import { useTranslation } from 'react-i18next';

import RenderCard from './RenderCard';

const IPAddress = ({ ip }: { ip: string }) => {
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });
  return (
    <RenderCard
      title={t('ipAddress.title')}
      value={ip}
      tooltip={t('ipAddress.tooltip')}
      dataTestId="ip-address-card"
      showCopyIcon={true}
    />
  );
};

export default IPAddress;
